import { frontendURL } from '../../../helper/URLHelper';
import LeadsIndex from './pages/LeadsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/leads'),
    name: 'leads_index',
    component: LeadsIndex,
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
];

export default routes;
